import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { IoMenuOutline, IoPeople, IoPersonAddOutline } from "react-icons/io5";
import { useLanguage } from "../contexts/LanguageContext";
import { languageOptions } from "../contexts/LanguageHelpers/LangOptions";
import { useAuth } from "../contexts/AuthContext";
import { BsPerson } from "react-icons/bs";
import { RxDividerVertical, RxExit } from "react-icons/rx";
import { FaCrown } from "react-icons/fa";
import { MdSpaceDashboard } from "react-icons/md";
import { GiHangingSpider, GiPumpkinMask, GiWitchFace } from "react-icons/gi";

const Navbar = () => {
    const { language, languageProps, changeLanguage } = useLanguage();
    const { user, logout, isAdmin, loading } = useAuth();

    const navigator = useNavigate();

    const menuRef = useRef(null)
    const buttonRef = useRef(null)
    const spiderRef = useRef(null)
    const threadRef = useRef(null)

    const [menuOpen, setMenuOpen] = useState(false)
    const [languageOpen, setLanguageOpen] = useState(false)
    const [profileOpen, setProfileOpen] = useState(false)
    const [show, setShow] = useState(false)
    const toggleMenu = () => setMenuOpen(!menuOpen)

    useEffect(() => {
        const handleTouchOutside = (event) => {
            const menuContainer = menuRef.current
            const buttonContainer = buttonRef.current
            if (menuContainer && !menuContainer.contains(event.target) && !buttonContainer.contains(event.target) && menuOpen) {
                setMenuOpen(false)
            }
        }
        document.addEventListener('touchend', handleTouchOutside)
        return () => {
            document.removeEventListener('touchend', handleTouchOutside)
        }
    }, [menuOpen])
    
    useEffect(() => {
        let direction = 1;
        let length = 40;
        let angle = 0;
        const maxLength = 70;
        const minLength = 40;
        const speed = 0.1;

        const animate = () => {
        length += direction * speed;
        if (length > maxLength || length < minLength) direction *= -1;

        angle = Math.sin(Date.now() / 500) * 5;
        if (threadRef.current) {
            threadRef.current.style.height = `${length}px`;
        }

        if (spiderRef.current) {
            spiderRef.current.style.transform = `translateY(${length}px) rotate(${angle}deg)`;
        }

        requestAnimationFrame(animate);
        };

        animate();
    }, []);

    const handleClick = () => {
        setShow(true);
        setTimeout(() => {
            setShow(false);
        }, 2000);
    }

    return (
        <nav className="navbar justify-between bg-[#180461a8]  rounded-xl lg:mx-auto max-w-[1300px] shadow-sm sm:px-10 mx-1 mt-5 z-10">
    <div className="absolute -left-4 flex flex-col items-center">
      <div
        ref={threadRef}
        style={{
          width: "2px",
          height: "40px",
          backgroundColor: "#9ca3af",
          transition: "height 0.2s linear",
        }}
      />
      <GiHangingSpider
        ref={spiderRef}
        style={{
          color: "#d1d5db",
          fontSize: "32px",
          marginTop: "-80px",
          transformOrigin: "top center",
        }}
      />
    </div>
            <div className="">
                <div className="">
                    <div className="cursor-pointer z-50" onClick={handleClick}>   
                        <span
                            className="text-5xl cursor-pointer absolute left-44 sm:left-48 2xl:-left-4 -top-4 -rotate-12 z-50"
                            style={{
                                opacity: show ? 0 : 1,                   
                                transition: "opacity 1.5s ease-in-out",
                            }}
                            onClick={() => setShow(true)}
                            >
                            🎃
                        </span>
                        <GiPumpkinMask
                            className={`text-5xl text-orange-600 bg-orange-300 rounded-full absolute left-[185px] sm:left-[200px] 2xl:-left-2 -top-3 -rotate-12`}
                            style={{
                                opacity: show ? 1 : 0,
                                transition: "opacity 1.2s ease-in-out",
                            }}
                        />
                    </div>
                    <span className="absolute -right-6 -bottom-4 text-5xl rotate-12"><GiWitchFace className="text-gray-300" /></span>
                </div>
                <a className="block cursor-pointer" href="/">
                    <img
                        src={"/Mobile2Logo.svg"}
                        alt="Mobile2 Logo"
                        className=""
                        width="180"
                    />
                </a>
            </div>
            {   
                (!loading && isAdmin) && 
                <div className="text-sm italic text-gray-300 flex items-center gap-2">
                    <FaCrown className="text-yellow-500" />
                    Admin
                </div>
            }
            <div className="hidden sm:flex ltr:ml-auto rtl:mr-auto relative">
                <ul className="hiddenmenu menu-horizontal items-center gap-1">
                    <li>
                        <div className={`border-none border-slate-500 rounded-full btn-sm w-10 h-10 p-1 bg-transparent cursor-pointer `} onClick={() => { setLanguageOpen(!languageOpen); setProfileOpen(false) }}>
                            <img src={"/" + languageProps.icon} alt={languageProps.name} className="w-8" />
                        </div>
                    </li>
                    {
                        user &&
                        <li>
                            <div className={`border border-slate-500 rounded-full text-2xl p-2 cursor-pointer items-center flex justify-center `} onClick={() => { setProfileOpen(!profileOpen); setLanguageOpen(false) }}>
                                <BsPerson />
                            </div>
                        </li>
                    }

                    <li>
                        {languageOpen &&
                        <ul className={`absolute z-50 right-0 top-11 menu p-1 bg-orange-700 rounded-md max-h-[500px] w-max shadow `}>
                            {
                                Object.values(languageOptions).map((lng) =>
                                    <li key={lng.code} className={`${language === lng.code ? "font-bold" : ""}`}>
                                        <span className="py-0.5 pl-2 pr-8" onClick={() => { changeLanguage(lng.code); setLanguageOpen(false) }}>
                                            <img src={"/" + lng.icon} alt={lng.name} className="w-8" />
                                            <span className="py-2 px-2">{lng.name}</span>
                                        </span>
                                    </li>
                                )
                            }
                        </ul>
                        }
                    </li>

                    <li>
                        {
                            (user && profileOpen) && (
                                <ul className={`absolute z-50 right-0 top-11 menu border border-orange-600 p-1 bg-orange-700 rounded-md max-h-[500px] shadow`}>
                                    {
                                        <div className="w-max min-w-40">
                                            {
                                                (!loading && isAdmin) &&
                                                <>
                                                    <li className="w-max">
                                                        <span 
                                                          className={ window.location.pathname === "/register" ? "py-0.5 pl-2 pr-8 bg-orange-600" : "py-0.5 pl-2 pr-8"}
                                                          onClick={() => { navigator("/register"); setLanguageOpen(false); setProfileOpen(false) }}
                                                          >
                                                            <span className="flex items-center gap-2 py-2 px-2"><IoPersonAddOutline /> Kullanıcı Oluştur </span>
                                                        </span>
                                                    </li>
                                                    <li className="w-max">
                                                        <span 
                                                          className={window.location.pathname === "/users" ? "py-0.5 pl-2 pr-8 bg-orange-600" : "py-0.5 pl-2 pr-8"} 
                                                          onClick={() => { navigator("/users"); setLanguageOpen(false); setProfileOpen(false) }}
                                                          >
                                                            <span className="flex items-center gap-2 py-2 px-2"><IoPeople /> Kullanıcı Tablosu </span>
                                                        </span>
                                                    </li>
                                                </>
                                            }
                                            <li>
                                                <span 
                                                  className={window.location.pathname === "/dashboard" ? "py-0.5 pl-2 pr-8 bg-gray-600" : "py-0.5 pl-2 pr-8" }
                                                  onClick={() => { navigator("/dashboard"); setLanguageOpen(false); setProfileOpen(false) }}
                                                  >
                                                    <span className="flex items-center gap-2 py-2 px-2"><MdSpaceDashboard /> Panel</span>
                                                </span>
                                            </li>
                                            <li>
                                                <span className="py-0.5 pl-2 pr-8" onClick={() => { logout(); setLanguageOpen(false) }}>
                                                    <span className="flex items-center gap-2 py-2 px-2 text-white-500"><RxExit /> Çıkış Yap </span>
                                                </span>
                                            </li>
                                        </div>
                                    }
                                </ul>
                            )
                        }
                        
                    </li>

                </ul>
            </div >
            <div className="sm:hidden flex-none relative gap-1 ltr:ml-auto rtl:mr-auto">
                <button className={`btn btn-sm w-10 h-10 btn-circle `} onClick={toggleMenu} ref={buttonRef}><IoMenuOutline size={20} /></button>
                {
                    menuOpen &&
                    <ul className="absolute top-full right-0 ltr:right-0 rtl:left-0 menu menu-horizontal items-center px-1 gap-0 z-[100]" ref={menuRef}>
                        <li>
                            <div className={`btn btn-sm w-32 `} onClick={() => changeLanguage("tr")}>Türkçe</div>
                        </li>
                        <li>
                            <div className={`btn btn-sm w-32 `} onClick={() => changeLanguage("en")}>English</div>
                        </li>
                    </ul>
                }
            </div>
        </nav >
    )
}

export default Navbar